module.exports = __webpack_public_path__ + "img/lesson.9f159eb4.gif";